import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _SVGIconWithSizes;

import { createSvg } from "../createSvg";
import { IconSize, SVGIconWithSizes } from "../interfaces";
export default createSvg('IconMoreHorizontal', new SVGIconWithSizes((_SVGIconWithSizes = {}, _defineProperty(_SVGIconWithSizes, IconSize.ExtraSmall, {
  paths: ['M1.6 6.4C0.7168 6.4 0 7.1168 0 8C0 8.8832 0.7168 9.6 1.6 9.6C2.4832 9.6 3.2 8.8832 3.2 8C3.2 7.1168 2.4832 6.4 1.6 6.4ZM8 6.4C7.1168 6.4 6.4 7.1168 6.4 8C6.4 8.8832 7.1168 9.6 8 9.6C8.8832 9.6 9.6 8.8832 9.6 8C9.6 7.1168 8.8832 6.4 8 6.4ZM12.8 8C12.8 7.1168 13.5168 6.4 14.4 6.4C15.2832 6.4 16 7.1168 16 8C16 8.8832 15.2832 9.6 14.4 9.6C13.5168 9.6 12.8 8.8832 12.8 8Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), _defineProperty(_SVGIconWithSizes, IconSize.Small, {
  paths: ['M2 8C0.896 8 0 8.896 0 10C0 11.104 0.896 12 2 12C3.104 12 4 11.104 4 10C4 8.896 3.104 8 2 8ZM10 8C8.896 8 8 8.896 8 10C8 11.104 8.896 12 10 12C11.104 12 12 11.104 12 10C12 8.896 11.104 8 10 8ZM16 10C16 8.896 16.896 8 18 8C19.104 8 20 8.896 20 10C20 11.104 19.104 12 18 12C16.896 12 16 11.104 16 10Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), _defineProperty(_SVGIconWithSizes, IconSize.Medium, {
  paths: ['M2.4 9.6C1.0752 9.6 0 10.6752 0 12C0 13.3248 1.0752 14.4 2.4 14.4C3.7248 14.4 4.8 13.3248 4.8 12C4.8 10.6752 3.7248 9.6 2.4 9.6ZM12 9.6C10.6752 9.6 9.6 10.6752 9.6 12C9.6 13.3248 10.6752 14.4 12 14.4C13.3248 14.4 14.4 13.3248 14.4 12C14.4 10.6752 13.3248 9.6 12 9.6ZM19.2 12C19.2 10.6752 20.2752 9.6 21.6 9.6C22.9248 9.6 24 10.6752 24 12C24 13.3248 22.9248 14.4 21.6 14.4C20.2752 14.4 19.2 13.3248 19.2 12Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), _defineProperty(_SVGIconWithSizes, IconSize.Large, {
  paths: ['M3.2 12.8C1.4336 12.8 0 14.2336 0 16C0 17.7664 1.4336 19.2 3.2 19.2C4.9664 19.2 6.4 17.7664 6.4 16C6.4 14.2336 4.9664 12.8 3.2 12.8ZM16 12.8C14.2336 12.8 12.8 14.2336 12.8 16C12.8 17.7664 14.2336 19.2 16 19.2C17.7664 19.2 19.2 17.7664 19.2 16C19.2 14.2336 17.7664 12.8 16 12.8ZM25.6 16C25.6 14.2336 27.0336 12.8 28.8 12.8C30.5664 12.8 32 14.2336 32 16C32 17.7664 30.5664 19.2 28.8 19.2C27.0336 19.2 25.6 17.7664 25.6 16Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));